import React from 'react';
import styled from 'styled-components';
import {
  Typography,
  Stack,
  DeleteIcon,
  StandardButton,
  TextField,
  textFieldClassNames,
  iconBaseClassNames,
} from '@moonsifttech/design-system';

import { EditModalContentContentProps } from './EditModalContent.types';

const UnstyledEditModalContentContent: React.FC<
  EditModalContentContentProps
> = ({
  className,
  style,
  showConfirmation,
  isPro,
  deleting,
  name,
  description,
  onDelete,
}) => {
  return (
    <div className={className} style={style}>
      {showConfirmation ? (
        <>
          <Typography
            className="EditModalContentContent-confirmationHeading"
            variant="primary.b26"
            component="h1"
          >
            Are you sure?
          </Typography>
          <Stack direction="column" justifyContent="center" alignItems="center">
            <DeleteIcon className="EditModalContentContent-confirmationIcon" />
            <Typography variant="primary.r16" align="center" component="p">
              The collection “{name}” and all items within it will be deleted.
              You cannot undo this.
            </Typography>
            <StandardButton
              variant="primary-white"
              loading={deleting}
              onClick={onDelete}
            >
              Delete
            </StandardButton>
          </Stack>
        </>
      ) : (
        <>
          <Typography variant="primary.b26" component="h1">
            Edit or delete collection
          </Typography>
          <Typography
            className="EditModalContentContent-formHeading"
            variant="primary.r14"
            color="grey.2"
            component="p"
          >
            Rename your collection
          </Typography>
          <TextField
            name="collectionName"
            defaultValue={name}
            maxLength={100}
            fullWidth
            autoFocus
          />
          {isPro && (
            <TextField
              name="collectionDescription"
              placeholder="Add a description (optional)"
              defaultValue={description}
              multiline
              maxLength={400}
              rows={5}
              fullWidth
            />
          )}
        </>
      )}
    </div>
  );
};

export const EditModalContentContent = styled(UnstyledEditModalContentContent)`
  .EditModalContentContent-confirmationHeading {
    margin-bottom: 60px;
  }

  .${iconBaseClassNames.root}.EditModalContentContent-confirmationIcon {
    font-size: 100px;
    margin-bottom: 12px;
  }

  .EditModalContentContent-formHeading {
    margin-bottom: 10px;
  }

  ${textFieldClassNames.root} {
    margin-bottom: 16px;
  }
`;
